import lazyWithRetry from "./utilities/lazyWithRetry";
import {
  configuration,
  ScanResults,
  AssetOnboarding as AssetOnboardingIcon,
} from "../assets/images/index";
import { PERMISSION } from "./rbac/permissions";
// ==================== AUTH MODULES ====================
const SignIn = lazyWithRetry(() => import("../app/auth/SignIn.js"));
const LicenseBackend = lazyWithRetry(
  () => import("../app/auth/LicenseBackend.js"),
);
const ConfigurationPage = lazyWithRetry(
  () => import("../app/auth/ConfigurationPage.js"),
);

// ==================== CONFIGURATION MODULES ====================
const Tools = lazyWithRetry(
  () => import("../Modules/configuration/admin/tools/Tools.js"),
);
const AuditLog = lazyWithRetry(
  () => import("../Modules/configuration/auditLog/AuditLog.js"),
);

const UserSession = lazyWithRetry(
  () => import("../Modules/configuration/userSessionLog/userSessionLog.js"),
);

// Administration Submodules
const UserManagement = lazyWithRetry(
  () => import("../Modules/configuration/admin/userManagement/UserManagement"),
);
const Schedulers = lazyWithRetry(
  () => import("../Modules/configuration/admin/Schedulers/ManageSchedulers.js"),
);

// Settings Submodules
const LdapConfig = lazyWithRetry(
  () => import("../Modules/configuration/settings/ldapConfig/LdapConfig.js"),
);
const SmtpConfig = lazyWithRetry(
  () => import("../Modules/configuration/settings/smtpConfig/SmtpConfig.js"),
);
const LicenseConfig = lazyWithRetry(
  () =>
    import("../Modules/configuration/settings/licenseConfig/LicenseConfig.js"),
);

const UserRoleMap = lazyWithRetry(
  () => import("../Modules/configuration/admin/UserRoleMap/UserRoleTable"),
);
const LoginPageConfig = lazyWithRetry(
  () =>
    import("../Modules/configuration/admin/loginPageConfig/LoginPageConfig"),
);

// ============================================== SASSP Module ===========================================
const AssetOnboarding = lazyWithRetry(
  () => import("../Modules/Inventory/AssetOnboarding/AssetOnboarding.js"),
);
const AssetApproval = lazyWithRetry(
  () => import("../Modules/Inventory/AssetApproval/AssetApproval.js"),
);
const ScanManagement = lazyWithRetry(
  () => import("../Modules/Inventory/AssetScan/ScanManagement.js"),
);
const Version = lazyWithRetry(() => import("./version/Version.js"));

export const authRoutes = [
  {
    name: "SignIn",
    path: "/logout",
    component: <SignIn />,
    key: 1,
  },
  {
    name: "SignIn",
    path: "/auth",
    component: <SignIn />,
    key: 2,
  },
  {
    name: "ConfigurationPage",
    path: "/ConfigurationPage",
    component: <ConfigurationPage />,
    key: 3,
  },
  {
    name: "LicenseBackend",
    path: "/LicenseBackend",
    component: <LicenseBackend />,
    key: 4,
  },
  {
    name: "Version",
    path: "/version",
    component: <Version />,
    key: 5,
  },
];

export const routes = [
  // Asset Onboarding (renamed from SASSP)
  {
    name: "Asset Onboarding",
    text: "Asset Onboarding",
    path: "assetOnboarding",
    component: <AssetOnboarding />,
    key: "2",
    icon: AssetOnboardingIcon,
    childNavs: [
      {
        name: "Onboard",
        text: "Onboard",
        path: "assetOnboarding/onboard",
        component: <AssetOnboarding />,
        key: "2.1",
        permission: PERMISSION.VIEW_ASSET_REQUEST,
      },
      {
        name: "Approval",
        text: "Approval",
        path: "assetOnboarding/approval",
        component: <AssetApproval />,
        key: "2.2",
        permission: PERMISSION.VIEW_ASSET_APPROVAL,
      },
    ],
  },

  // Scan Management
  {
    name: "Scan Management",
    text: "Scan Management",
    path: "scanManagement",
    component: <ScanManagement />,
    key: "4",
    icon: ScanResults,
    permission: PERMISSION.VIEW_SCAN_RESULTS,
  },

  // Configuration Section
  {
    name: "Configuration",
    path: "configuration",
    component: <Tools />,
    key: "3",
    icon: configuration,
    childNavs: [
      {
        name: "Administration",
        text: "Administration",
        path: "configuration/administration/directoryConfig",
        navigationDisable: true,
        customDropContainerClass: "admin",
        component: <LdapConfig />,
        key: "3.2",
        childNavs: [
          {
            name: "UserManagement",
            text: "User Management",
            path: "configuration/administration/userManagement",
            component: <UserManagement />,
            key: "3.2.1",
            permission: PERMISSION.VIEW_USERS,
          },
          {
            name: "UserRoleMap",
            text: "Role Mapping",
            isNotSideBarNavigation: true,
            path: "configuration/administration/userManagement/rolemapping",
            component: <UserRoleMap />,
            key: "3.2.2",
            permission: PERMISSION.VIEW_AD_GROUPS,
          },
          {
            name: "Schedulers",
            text: "Schedulers",
            path: "configuration/administration/Schedulers",
            component: <Schedulers />,
            key: "3.2.3",
            permission: PERMISSION.VIEW_EMAIL_SCHEDULER,
          },
          {
            name: "Tools",
            text: "Tools",
            path: "configuration/administration/tools",
            component: <Tools />,
            key: "3.2.4",
            permission: PERMISSION.VIEW_TOOLS_LIST,
          },
          {
            name: "LoginPageConfig",
            text: "Login Page Configuration",
            path: "configuration/administration/loginPageConfiguration",
            component: <LoginPageConfig />,
            key: "3.2.5",
            permission: PERMISSION.EDIT_LOGIN_BANNER,
          },
        ],
      },
      {
        name: "Settings",
        text: "Settings",
        path: "configuration/settings/tools",
        navigationDisable: true,
        customDropContainerClass: "settings",
        component: <Tools />,
        key: "3.3",
        childNavs: [
          {
            name: "Directory Configuration",
            text: "Directory Configuration",
            path: "configuration/settings/directoryConfiguration",
            component: <LdapConfig />,
            key: "3.3.1",
            permission: PERMISSION.MANAGE_AD_CONFIG,
          },
          {
            name: "SmtpConfig",
            text: "SMTP Configuration",
            path: "configuration/settings/smtpConfiguration",
            component: <SmtpConfig />,
            key: "3.3.2",
            permission: PERMISSION.MANAGE_SMTP_CONFIG,
          },
          {
            name: "LicenseConfig",
            text: "License Configuration",
            path: "configuration/settings/licenseConfiguration",
            component: <LicenseConfig />,
            key: "3.3.3",
            permission: PERMISSION.MANAGE_LICENSE_CONFIG,
          },
        ],
      },
      {
        name: "AuditLog",
        text: "Audit Log",
        path: "configuration/auditLog",
        component: <AuditLog />,
        key: "3.4",
        permission: PERMISSION.VIEW_AUDIT_LOG,
      },
      {
        name: "UserSession",
        text: "User Session",
        path: "configuration/usersession",
        component: <UserSession />,
        key: "3.5",
        permission: PERMISSION.VIEW_USER_SESSION,
      },
    ],
  },
];
